import { useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { AccessAccount, admin_permission_detail, organizationData, userBlockUnblock, userDelete } from "../../../api/apiHandler";
import DataTable from "react-data-table-component";
import FontAwesome from "react-fontawesome";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import SwalOld from "sweetalert"
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Swal from "sweetalert2";
import { CButton, CFormInput, CInputGroup } from "@coreui/react";
import customStyles from "../../../utils/dataTableStyles";
// OLD CODE (kept as it is) :
// import { encryptString } from "../../../api/apiClient";
import { encryptString, decryptString } from "../../../api/apiClient";
import { WEB_URL } from "../../../Config";
import useDebounce from "../../../utils/useDebounce";

export default function OrgTeacherDetails({ isLoader }) {

    const [data, setData] = useState([])
    const navigate = useNavigate()
    const [activeActionPending, setActiveActionPending] = useState(false);
    const AdminId = localStorage.getItem("aID")
    const [permissions, setPermission] = useState([]);
    const role = localStorage.getItem("adminRole");
    const [search, setSearch] = useState('')
    const debounceSearch = useDebounce(search, 750);

    /* ===== STATUS FILTER - START ===== */
    // Same filter behaviour as the New Classes listing : the selected status is sent
    // to the listing API (is_status) and an empty value lists all the records.
    const [statusType, setStatusType] = useState("");
    // toggled on every status change so the table goes back to the first page
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    // Function to handle status filter
    const handleStatusFilter = (type) => {
        setStatusType(type);
        setResetPaginationToggle((prev) => !prev);
    };

    const resetFilters = () => {
        handleStatusFilter("");
    };
    /* ===== STATUS FILTER - END ===== */

    const GetOrganizationData = () => {
        isLoader(true)
        // OLD CODE (kept as it is) :
        // organizationData({ search: search }).then((response) => {
        organizationData({ search: search, is_status: statusType }).then((response) => {
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setData(dataWithRowCount);
                isLoader(false)
            } else {
                setData([])
                isLoader(false)
            }
        })
    }

    const handleDelete = async (id) => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure you want to delete?",
            showCancelButton: true,
            confirmButtonText: "Delete",
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    isLoader(true)
                    userDelete({ id: id }).then((response) => {
                        if (response.code == 1) {
                            setData((prevData) => prevData.filter((user) => user.id !== id))
                            TOAST_SUCCESS(response.message);
                            isLoader(false)
                        } else {
                            TOAST_ERROR(response.message);
                            isLoader(false)
                        }
                    })
                } catch (error) {
                    TOAST_ERROR("Error!");
                }
            }
        });
    };

    const handleView = (id, name) => {
        navigate('/org_details', { state: { userId: id, name: name } })
    }

    const handleView2 = (id) => {
        navigate('/organizationteacherdetails', { state: { orgId: id } });
    }

    const clickActive = (id, is_active, full_name, email) => {
        const actionText = is_active === 1 ? 'block' : 'unblock';
        setActiveActionPending(true)
        SwalOld({
            title: 'Are you sure?',
            text: 'You want to ' + actionText + ' this organization ?',
            icon: 'warning',
            buttons: {
                confirm: {
                    text: is_active === 1 ? 'Block' : 'Unblock',
                    className: 'btn-success'
                },
                cancel: 'Cancel',
            },
            dangerMode: true,
        })
            .then((activate) => {
                setActiveActionPending(false);
                if (activate) {
                    if (is_active === 1) {
                        HandleMakeInactive(id, email, full_name);
                    } else {
                        HandleMakeActive(id, email, full_name);
                    }
                } else {
                    GetOrganizationData();
                }
            });
    }

    const HandleMakeActive = async (id, email, full_name) => {

        let catid = `${id}`
        let objCategory = {
            id: catid,
            is_active: "1",
            name: full_name,
            email: email
        };
        isLoader(true)
        userBlockUnblock((objCategory)).then((response) => {
            if (response.code == "1") {
                updateLearnerStatus(id, 1);
                TOAST_SUCCESS(response.message);
                GetOrganizationData();
                isLoader(false)
            } else {
                TOAST_ERROR(response.message);
                isLoader(false)
            }
        })
    };

    const HandleMakeInactive = async (id, email, full_name) => {

        let catid = `${id}`
        let objCategory = {
            id: catid,
            is_active: "0",
            name: full_name,
            email: email
        };
        isLoader(true)
        userBlockUnblock((objCategory)).then((response) => {
            if (response.code == "1") {
                updateLearnerStatus(id, 0);
                TOAST_SUCCESS(response.message);
                GetOrganizationData();
                isLoader(false)
            } else {
                TOAST_ERROR(response.message);
                isLoader(false)
            }
        })
    };

    const updateLearnerStatus = (id, status) => {
        setData(prevData =>
            prevData.map(learner =>
                learner.id === id ? { ...learner, is_active: status } : learner
            )
        );
    };

    const subAdminPermission = () => {
        admin_permission_detail({ id: AdminId })
            .then((response) => {
                if (response.code == 1) {
                    setPermission(response.data);
                } else {
                    setPermission([]);
                }
            })
            .catch((error) => {
                setPermission([]);
            });
    }

    useEffect(() => {
        GetOrganizationData()
        if (role !== "S") {
            subAdminPermission();
        }
        // OLD CODE (kept as it is) :
        // }, [debounceSearch])
    }, [debounceSearch, statusType])

    const organizationPermission = permissions.find(permission => permission.menu_name === "Organization");

    // Check if status and deleting is allowed for "Organizations"
    const isDeleteAllowed = organizationPermission && organizationPermission.delete === 1;
    const isStatusAllowed = organizationPermission && organizationPermission.status === 1;

    const getStatus = (step) => {
        switch (step) {
            case 0:
                return <button className="bg-warning border-0" style={{ width: "70px" }}>Pending</button>;
            case 1:
                return <button className="bg-warning border-0" style={{ width: "70px" }}>Pending</button>;
            case 2:
                return <button className="bg-success border-0 text-light" style={{ width: "70px" }}>Accepted</button>;
            case 3:
                return <button className="bg-danger text-light border-0" style={{ width: "70px" }}>Rejected</button>;
            default:
                return "";
        }
    };

    const handleView3 = (id) => {
        navigate('/org_class_list', { state: { org_id: id } });
    }

    const handleRedirect = (id, category) => {
        isLoader(true)
        AccessAccount({ user_id: id })
            .then((response) => {
                if (response.code === "1") {

                    localStorage.setItem("Ttoken", response.data[0]?.token);
                    localStorage.setItem("TisLogin", true)
                    localStorage.setItem("type", category)
                    localStorage.setItem("Tid", id)
                    localStorage.setItem("role", "admin");
                    isLoader(false);

                    // navigate('${WEB_URL}my_class_details', {
                    //     state: { id }
                    // })

                    // const url = `${WEB_URL}my_class_details`;
                    // window.open(url, '_blank'); 

                    const encryptedId = encryptString(id);

                    const url = `${WEB_URL}organization-profile-details/${encryptedId}`;
                    window.open(url, '_blank');

                } else {
                    isLoader(false);
                    TOAST_ERROR("ERROR..!!");
                }
            })
            .catch((error) => {
                TOAST_ERROR("ERROR..!!");
            });
    };

    /* ===== ADMIN LOGIN FLOW - START ===== */
    // When the Admin clicks on an Organization's full name, the login screen is opened
    // on the web app with that organization's email & password already pre-filled and
    // with an extra "Admin Login" flag, so the system can identify that the login has
    // been initiated by an Admin. The organization profile page that the earlier flow
    // opened directly is sent along as the page to land on once the login is done.
    const handleOrgAdminLogin = (row) => {
        try {
            const orgPassword = decryptString(row?.password);
            const encryptedId = encryptString(row?.id);

            const adminLoginPayload = {
                email: row?.email,
                password: orgPassword,
                is_admin_login: 1,          // Admin Login flag
                user_id: row?.id,
                category: row?.category,
                admin_id: AdminId,
                // Organizations registered through a social account (F / G) do not have a
                // usable password, so their login type / social id is carried along and
                // the existing social login flow is used for them.
                login_type: (row?.login_type != undefined && row?.login_type != null && row?.login_type != '') ? row?.login_type : "S",
                social_id: row?.social_id,
                // page the organization has to land on once the login is done
                redirect_url: `organization-profile-details/${encryptedId}`,
            };

            const encryptedPayload = encryptString(JSON.stringify(adminLoginPayload));
            const url = `${WEB_URL}login?admin_login=${encryptedPayload}`;

            // A fixed window name is used so that selecting another organization reuses
            // the same tab, replacing the previously opened one.
            const adminLoginWindow = window.open(url, 'studentscholars_admin_login');
            if (adminLoginWindow) {
                adminLoginWindow.focus();
            }
        } catch (error) {
            console.log('handleOrgAdminLogin error :', error);
            TOAST_ERROR("ERROR..!!");
        }
    };
    /* ===== ADMIN LOGIN FLOW - END ===== */

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "70px"
        },
        {
            name: (
                <>
                    Registered<br />Date
                </>
            ),
            selector: row => {
                const date = new Date(row.created_at);
                const day = date.getDate();
                const month = date.getMonth() + 1;
                const formattedMonth = month < 10 ? `0${month}` : month;
                const formattedDay = day < 10 ? `0${day}` : day;
                const year = date.getFullYear();
                return `${formattedDay}-${formattedMonth}-${year}`;
            },
            sortable: true,
            // width: "100px"
        },
        {
            name: (
                <>
                    Id<br />Code
                </>
            ),
            // selector: row => row.code_generate,
            selector: row => (
                <span onClick={() => handleView(row.id, row.full_name)} style={{ cursor: 'pointer', color: "rgb(87, 8, 97)" }}>
                    {row.code_generate}
                </span>
            ),
            sortable: true,
            width: "60px",
            // cell: row => row.code_generate == null ? "0000" : row.code_generate
        },
        {
            name: 'Image',
            cell: (data) => (
                <img
                    src={data.profile_image}
                    style={{ width: '50px', height: '50px' }}
                />
            ),
            sortable: true,
            width: "80px"
        },
        {
            name: 'Full Name',
            selector: row => (
                <span
                    // onClick={() => handleView(row.id , row.full_name)}
                    // OLD CODE (kept as it is) :
                    // onClick={() => handleRedirect(row.id, row.category)}
                    onClick={() => handleOrgAdminLogin(row)}
                    style={{ cursor: 'pointer', color: "rgb(87, 8, 97)" }}>
                    {row.full_name}
                </span>
            ),
            sortable: true,
            width: "150px"
        },
        // {
        //     name: 'Email',
        //     selector: row => row.email,
        //     sortable: true,
        //     width: "200px"
        // },
        {
            name: 'Country',
            selector: row => row.user_country,
            sortable: true,
            width: "140px"
        },
        {
            name: `Teacher`,
            cell: (row) => (
                <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }} onClick={() => handleView2(row.id)}>View</button>
            ),
            sortable: true,
            width: "90px"
        },
        {
            name: 'Actions',
            width: "100px",
            cell: (row) => (
                <div className="d-flex justify-content-center">
                    {(role === "S" || isDeleteAllowed) &&
                        <div className="col me-2">
                            <FontAwesome
                                name="delete"
                                className="fs-5 fa-solid fa-trash  mx-2 my-2 bg-light text-danger"
                                onClick={() => handleDelete(row.id)}
                            ></FontAwesome>
                        </div>
                    }
                    <div className="col me-2">
                        <FontAwesome
                            name="view"
                            className="fs-5 fa-solid fa-eye  mx-2 my-2 bg-light text-secondary"
                            onClick={() => handleView(row.id, row.full_name)}
                        ></FontAwesome>
                    </div>
                </div>
            ),
        },
        {
            name: 'Application',
            // cell: (row) => getStatus(row.step_1),
            cell: (row) => (
                <button onClick={() => navigate("/organization-applications-details", { state: { oID: row.id, email: row.email, name: row.full_name } })} className={`${row.step_1 == 0 ? "bg-info border-0" : row.step_1 == 1 ? "bg-warning border-0" : row.step_1 == 2 ? "bg-success text-light border-0" : row.step_1 == 3 ? "bg-danger text-light border-0" : ""}`} style={{ width: "70px" }}>{row.step_1 == 0 ? "Not Submitted" : row.step_1 == 1 ? "Pending" : row.step_1 == 2 ? "Accepted" : row.step_1 == 3 ? "Rejected" : ""}</button>
            ),
            sortable: true,
            // width: "110px"
        },
        {
            name: (
                <>
                    Id<br />Verification
                </>
            ),
            // cell: (row) => getStatus(row.step_2),
            cell: (row) => (
                <button onClick={() => navigate("/organization-identity-verification", { state: { oId: row.id, email: row.email, oname: row.full_name } })} className={`${row.step_2 == 0 ? "bg-info border-0" : row.step_2 == 1 ? "bg-warning border-0" : row.step_2 == 2 ? "bg-success text-light border-0" : row.step_2 == 3 ? "bg-danger text-light border-0" : ""}`} style={{ width: "70px" }}>{row.step_2 == 0 ? "Not Submitted" : row.step_2 == 1 ? "Pending" : row.step_2 == 2 ? "Accepted" : row.step_2 == 3 ? "Rejected" : ""}</button>
            ),
            sortable: true,
            // width: "110px"
        },
        {
            name: (
                <>
                    Organization<br />Agreement
                </>
            ),
            // cell: (row) => getStatus(row.step_3),
            cell: (row) => (
                <button onClick={() => navigate("/organization-agreement", { state: { orgID: row.id, email: row.email, oName: row.full_name } })} className={`${row.step_3 == 0 ? "bg-info border-0" : row.step_3 == 1 ? "bg-warning border-0" : row.step_3 == 2 ? "bg-success text-light border-0" : row.step_3 == 3 ? "bg-danger text-light border-0" : ""}`} style={{ width: "70px" }}>{row.step_3 == 0 ? "Not Submitted" : row.step_3 == 1 ? "Pending" : row.step_3 == 2 ? "Accepted" : row.step_3 == 3 ? "Rejected" : ""}</button>
            ),
            sortable: true,
            // width: "110px"
        },
        {
            name: (
                <>
                    Authorization<br />to teach in person
                </>
            ),
            // cell: (row) => getStatus(row.step_4),
            cell: (row) => (
                <button onClick={() => navigate("/organization-authorization", { state: { orgId: row.id, email: row.email, orgname: row.full_name } })} className={`${row.step_4 == 0 ? "bg-info border-0" : row.step_4 == 1 ? "bg-warning border-0" : row.step_4 == 2 ? "bg-success text-light border-0" : row.step_4 == 3 ? "bg-danger text-light border-0" : ""}`} style={{ width: "70px" }}>{row.step_4 == 0 ? "Not Submitted" : row.step_4 == 1 ? "Pending" : row.step_4 == 2 ? "Accepted" : row.step_4 == 3 ? "Rejected" : ""}</button>
            ),
            sortable: true,
            // width: "120px"
        },
        {
            name: (
                <>
                    In-person<br />Edit Request
                </>
            ),
            // latest in-person location change request sent by the organization (pending / accepted / rejected)
            selector: row => row.location_change_status || "",
            cell: (row) => (
                <button onClick={() => navigate("/organization-authorization", { state: { orgId: row.id, email: row.email, orgname: row.full_name } })} className={`${row.location_change_status == "pending" ? "bg-warning border-0" : row.location_change_status == "accepted" ? "bg-success text-light border-0" : row.location_change_status == "rejected" ? "bg-danger text-light border-0" : "bg-secondary text-light border-0"}`} style={{ width: "70px" }}>{row.location_change_status == "pending" ? "Pending" : row.location_change_status == "accepted" ? "Accepted" : row.location_change_status == "rejected" ? "Rejected" : "No Request"}</button>
            ),
            sortable: true,
        },
        {
            name: (
                <>
                    Organization<br />Profile
                </>
            ),
            // cell: (row) => getStatus(row.step_5),
            cell: (row) => (
                <button onClick={() => navigate("/org-profile", { state: { orgId: row.id, email: row.email, orgName: row.full_name } })} className={`${row.step_5 == 0 ? "bg-info border-0" : row.step_5 == 1 ? "bg-warning border-0" : row.step_5 == 2 ? "bg-success text-light border-0" : row.step_5 == 3 ? "bg-danger text-light border-0" : ""}`} style={{ width: "70px" }}>{row.step_5 == 0 ? "Not Submitted" : row.step_5 == 1 ? "Pending" : row.step_5 == 2 ? "Accepted" : row.step_5 == 3 ? "Rejected" : ""}</button>
            ),
            sortable: true,
            // width: "120px"
        },
        {
            name: (
                <>
                    Class<br />List
                </>
            ),
            cell: (row) => (
                <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }} onClick={() => handleView3(row.id, row.organization_id)}>View</button>
            ),
            sortable: true,
            width: "60px"
        },

        {
            name: role == "S" || isStatusAllowed ? 'Block/UnBlock' : '',
            cell: (row) => (
                <div className="d-flex justify-content-center">
                    {(role === "S" || isStatusAllowed) && (
                        <BootstrapSwitchButton
                            checked={row.is_active === 1}
                            onlabel='Block'
                            offlabel='UnBlock'
                            width={90}
                            size="sm"
                            onChange={() => {
                                { clickActive(row.id, row.is_active, row.email, row.full_name) }
                            }}
                        />
                    )}
                </div>
            ),
        },
    ]

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>

                    </div>
                </header>
                <>
                    <div className="fs-3 fw-500 mt-4 ms-4 mb-2">
                        Organization Data
                    </div>
                    <div className="d-flex justify-content-end align-items-center mb-4 search-container">
                        {/* ===== STATUS FILTER - START ===== */}
                        <div className="d-flex align-items-center me-3">
                            <div className="dropdown">
                                <button className="btn border-purple rounded-cricle rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Organization Status
                                </button>
                                <div className="dropdown-menu class_size_start filter_box">
                                    <h3 className="fs-5 mb-3">Organization Status</h3>
                                    <form className="" action="" id="">
                                        {[
                                            { value: "", label: "All" },
                                            { value: "accepted", label: "Accepted" },
                                            { value: "pending", label: "Pending" },
                                            { value: "rejected", label: "Rejected" },
                                            { value: "not_submitted", label: "Not Submitted" },
                                        ].map((option) => (
                                            <div className="form-check" key={option.value || "all"}>
                                                <input className="form-check-input" type="radio" name="orgStatusFilter" id={`orgStatus_${option.value || "all"}`}
                                                    onChange={() => handleStatusFilter(option.value)} checked={statusType == option.value} />
                                                <label className="form-check-label" htmlFor={`orgStatus_${option.value || "all"}`}>
                                                    {option.label}
                                                </label>
                                            </div>
                                        ))}
                                    </form>
                                </div>
                            </div>
                            <div className="ms-4" onClick={resetFilters}><a href="#" onClick={(e) => e.preventDefault()} className="text-purple fw-500">Reset Filters</a></div>
                        </div>
                        {/* ===== STATUS FILTER - END ===== */}
                        <div className="row me-5">
                            <div className="col">
                                <CInputGroup>
                                    <CFormInput type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                                    <CButton style={{ backgroundColor: "rgb(87, 8, 97)", color: "light" }}>
                                        <FontAwesome className="fa-solid fa-search" name="search" />
                                    </CButton>
                                </CInputGroup>
                            </div>
                        </div>
                    </div>
                    <div className="px-4 mt-1">
                        <div>
                            {(data && data.length > 0 ? (
                                <>
                                    {/* OLD CODE (kept as it is) : <DataTable columns={columns} data={data} pagination customStyles={customStyles} /> */}
                                    <DataTable columns={columns} data={data} pagination paginationResetDefaultPage={resetPaginationToggle} customStyles={customStyles} />
                                </>
                            ) : (
                                <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                            )
                            )}
                        </div>
                    </div>
                </>
            </div>
        </main>
    </>
}